import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import i18n from './i18n/i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {IonicVue, toastController} from '@ionic/vue';
import interceptorsSetup from "@/helpers/interceptors";
import store from "@/store/store";

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/main.css';
import { AuthLib } from "vue-app-auth-lib";

// Added by the CLI
import './registerServiceWorker';



interceptorsSetup();
const customLoginProcess = async function () {
  if (AuthLib.getUser()?.llistaClients.length !== 1) {
    const toast = await toastController.create({
      message: i18n.global.t("interceptors.noAuthorized"),
      duration: 1500,
      position: "bottom",
    });
    await toast.present();
    AuthLib.logOut();
  } else {
    const path = router.currentRoute.value.path === "/login-page" ? "/" : router.currentRoute.value.path;
	await router.push({ path, replace: true });
  }
}

AuthLib.initAuthLib(import.meta.env.VITE_CODI_EMPRESA, router, axios, { baseUrl: import.meta.env.VITE_API_URL, overwriteLoginProcess: customLoginProcess });

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(i18n)
  .use(store);

app.use(VueAxios, axios);
app.provide('axios', app.config.globalProperties.axios);

router.isReady().then(async () => {
  try {
    await store.dispatch('loadConfiguracio');
  } catch (error) {
    console.error('No s\'ha pogut carregar la configuracio inicial', error);
  }

  app.mount('#app');
});


